<template>
  <ul>
    <li class="dropdown-item">
     {{ $t('root.filters.deleted_at')}}
      <select @click.stop @change='filter'>
        <option>{{ $t('root.filters.choose_interval') }}</option>
        <option value='1'>{{ $t('root.filters.deleted_last_24') }}</option>
        <option value='7'>{{ $t('root.filters.deleted_last_week') }}</option>
        <option value='30'>{{ $t('root.filters.deleted_last_month') }}</option>
      </select>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      folder: {
        type: Object,
        default: () => { return {} },
      },
    },
    methods: {
      filter(e) {
        const v = e.target.value

        if (v.length) {
          let d = new Date()
          d.setDate(d.getDate() - e.target.value)
          this.$router.push({ query: Object.assign({}, this.query, { page: 1, parent_id: this.folder.id, 'filters[deleted_at_gteq]': d.toISOString() }) })
        } else {
          let newQuery = Object.assign({}, this.query)
          delete newQuery['filters[created_at_gteq]']
          this.$router.push({ query: newQuery })
        }
      },
    }
  }
</script>

<style lang="sass" scoped>
  ul
    width: 220px
</style>

